// extracted by mini-css-extract-plugin
export default {"ZoomableImage":"ZoomableImage-module-bc9cf7349a39e4e95f24"};